module.exports = __webpack_public_path__ + "media/images/features/6/feature-6-item-option-4d81237537279e24e2843b0d4e93e36b.png";